import React from 'react'
import { useNavigate } from 'react-router-dom'
import './NotFoundPage.css'

/**
 * Renders the 404 Not Found error page with an option to navigate back
 * to the previous page or return to the root application route.
 *
 * @returns The 404 error page component.
 */
const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()

  /**
   * Handles returning the user to their previous valid page in history,
   * falling back to the root route if no prior session history exists.
   */
  const handleGoHome = () => {
    if (globalThis.history.state?.idx > 0 || globalThis.history.length > 1) {
      navigate(-1)
    } else {
      navigate('/')
    }
  }

  return (
    <div className="not-found-page page-container">
      <div className="decor-orbs" aria-hidden>
        <div className="orb orb1" />
        <div className="orb orb2" />
        <div className="orb orb3" />
      </div>

      <div className="content">
        <h1>
          <span className="digit">4</span>
          <span className="digit">0</span>
          <span className="digit">4</span>
        </h1>

        <h2 className="fade-up">Page Not Found</h2>
        <p className="fade-up delay">The page you are looking for does not exist.</p>

        <button
          type="button"
          onClick={handleGoHome}
          className="home-link pulse"
        >
          Go to Home
        </button>
      </div>
    </div>
  )
}

export default NotFoundPage
